"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _immutable = require("immutable");

var _q = _interopRequireDefault(require("q"));

var _underscore = _interopRequireDefault(require("underscore"));

var _FulcrumJS = _interopRequireDefault(require("FulcrumJS.fulcrum"));

var _default = {
  get: _underscore.default.once(function () {
    return _q.default.Promise.all([_FulcrumJS.default.getUserAge(), _FulcrumJS.default.getPortalAge()]).then(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          userAge = _ref2[0],
          portalAge = _ref2[1];

      return (0, _immutable.fromJS)({
        user: {
          days: userAge.days,
          months: userAge.months
        },
        portal: {
          days: portalAge.days,
          months: portalAge.months
        }
      });
    });
  })
};
exports.default = _default;
module.exports = exports.default;